var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-overlay',{attrs:{"value":_vm.overlay}},[_c('div',{staticClass:"d-flex flex-column",staticStyle:{"text-align":"center"}},[_c('v-progress-circular',{staticStyle:{"align-self":"center"},attrs:{"indeterminate":"","size":"64"}}),_c('br'),_c('div',{domProps:{"innerHTML":_vm._s(_vm.getMessage)}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }